export const SERVICE_CONFIG_LEGEND_TITLE = "Legenda configurazione servizio import";

export const SERVICE_CONFIG_LEGEND_SECTIONS = [
  {
    title: "Import",
    items: [
      {
        value: "Import catalogo abilitati",
        description:
          "Kill switch globale del microservizio CaricamentoCatalogo. Se disattivato, il servizio rifiuta qualsiasi import avviato da Admin e qualsiasi ciclo schedulato. Non disabilita la consultazione mapping o la configurazione runtime.",
      },
    ],
  },
  {
    title: "Scheduling",
    items: [
      {
        value: "Modalita scheduling",
        description:
          "Due modalita: Disattivato (nessun import automatico) oppure Orari fissi (esecuzione cron-like agli orari configurati in Europe/Rome).",
      },
      {
        value: "Orari (Europe/Rome)",
        description:
          "Visibile solo con modalita Orari fissi. Inserire ora (0-23) e minuti (0-59) con il pulsante + (es. 14:31). In salvataggio vengono convertiti in UTC e persistiti in scheduled_import_times_utc. Ogni orario viene eseguito una sola volta al giorno, con precisione al minuto.",
      },
    ],
  },
  {
    title: "Prestazioni import",
    items: [
      {
        value: "Batch vendor",
        description:
          "Numero di vendor processati consecutivamente prima della pausa batch. Controlla il parallelismo effettivo del job multi-vendor e riduce il picco di carico su DB e rete.",
      },
      {
        value: "Pausa batch vendor (sec)",
        description:
          "Secondi di attesa tra un batch di vendor e il successivo. Utile per evitare saturazione del database o del feed remoto durante import massivi o schedulati.",
      },
      {
        value: "Batch upsert righe",
        description:
          "Numero di righe classificate (UPDATE + INSERT) elaborate in un'unica transazione PostgreSQL per ciclo di scrittura. Valori piu alti riducono il numero di commit e aumentano throughput e memoria; valori piu bassi limitano la durata delle transazioni e il rischio di timeout su DB remoti. Persistito come import_batch_size.",
      },
      {
        value: "Chunk SQL bulk",
        description:
          "Dimensione massima di ogni blocco di statement SQL bulk (UPDATE multipli, INSERT ... RETURNING, disabilitazioni) inviato al database all'interno di un batch. Suddivide operazioni molto grandi in piu round-trip controllati senza cambiare la logica di match o validazione. Persistito come import_bulk_execute_chunk_size.",
      },
      {
        value: "Soglia temp table ID visti",
        description:
          "Numero minimo di catalog_list_id visti durante l'import oltre il quale la fase finale mark_missing usa una tabella temporanea PostgreSQL invece del filtro NOT IN su array. Consigliato per vendor con decine di migliaia di righe: evita query con array enormi e mantiene prestazioni stabili su DB remoti. Persistito come import_seen_temp_table_threshold.",
      },
    ],
  },
  {
    title: "Azioni HTTP post-import",
    items: [
      {
        value: "Reindex dopo import schedulato",
        description:
          "Al termine di un job import_type=scheduled, se attivo invia POST {base}/index a RicercaProdotti per reindicizzare l'intero catalogo Elasticsearch.",
      },
      {
        value: "Reindex dopo import manuale totale (Importa tutti)",
        description:
          "Al termine di un job import_type=manual_all (bottone Importa tutti), se attivo invia POST {base}/index per un reindex completo del catalogo.",
      },
      {
        value: "Reindex vendor dopo import manuale selezionati (full)",
        description:
          "Per job import_type=manual_selected avviati dalla pagina principale su vendor selezionati (flusso full: download, normalizzazione, mapping, import), se attivo invia POST {base}/index/vendor/{id} per ogni vendor importato con successo.",
      },
      {
        value: "Reindex vendor dopo import manuale singolo full",
        description:
          "Per job import_type=manual_single avviati dal bottone Play sulla riga vendor (pagina principale) o dal bottone in alto su operazioni-vendor (flusso full), se attivo invia POST {base}/index/vendor/{id} per il vendor importato con successo.",
      },
      {
        value: "Reindex vendor dopo import manuale singolo (feed normalizzato)",
        description:
          "Per job import_type=manual_stored avviati dalla tab Revisione e Mapping con use_stored_feed=true, se attivo invia POST {base}/index/vendor/{id} per il vendor importato con successo.",
      },
      {
        value: "Base URL RicercaProdotti (interno)",
        description:
          "URL base diretto verso MS RicercaProdotti per le chiamate HTTP post-import, tipicamente http://127.0.0.1:31003 in locale o http://ms-ricerca:31003 in Docker. Se impostata, la variabile d'ambiente INTERNAL_RICERCA_BASE_URL ha priorita sul valore runtime.",
      },
      {
        value: "Timeout HTTP (sec)",
        description:
          "Timeout in secondi per ogni chiamata HTTP post-import verso RicercaProdotti. Errori di rete o timeout vengono loggati ma non bloccano la chiusura del job import.",
      },
      {
        value: "Registra job import in DB (import_jobs)",
        description:
          "Se attivo, al termine del job scrive una riga per vendor nella tabella import_jobs (job_id univoco per vendor, conteggi record/errori, snapshot summary JSON solo se warning/errori). Alimenta lo storico del portale vendor.",
      },
    ],
  },
  {
    title: "Notifiche email",
    items: [
      {
        value: "Email report Excel dopo import schedulato",
        description:
          "Se attivo, al termine di un job import_type=scheduled invia email SMTP con allegato Excel riepilogativo per vendor. Richiede destinatari configurati e credenziali SMTP in env del servizio.",
      },
      {
        value: "Email report Excel dopo import manuale totale (Importa tutti)",
        description:
          "Se attivo, al termine di un job import_type=manual_all invia email SMTP con allegato Excel riepilogativo per vendor.",
      },
      {
        value: "Email report Excel dopo import manuale selezionati (full)",
        description:
          "Se attivo, al termine di un job import_type=manual_selected avviato dalla pagina principale invia email SMTP con allegato Excel.",
      },
      {
        value: "Email report Excel dopo import manuale singolo full",
        description:
          "Se attivo, al termine di un job import_type=manual_single avviato dal bottone Play sulla riga vendor o dal bottone in alto su operazioni-vendor invia email SMTP con allegato Excel.",
      },
      {
        value: "Email report Excel dopo import manuale singolo (feed normalizzato)",
        description:
          "Se attivo, al termine di un job import_type=manual_stored avviato dalla tab Revisione e Mapping invia email SMTP con allegato Excel.",
      },
      {
        value: "Destinatari report",
        description:
          "Elenco email destinatari del report Excel. Aggiungi un indirizzo per volta con il bottone + oppure premi Invio. I destinatari aggiunti compaiono come chip rimovibili. Persistiti in runtime-config come import_report_recipients. In assenza di destinatari configurati il servizio usa anche la variabile env IMPORT_REPORT_RECIPIENTS come fallback.",
      },
    ],
  },
  {
    title: "Sistema",
    items: [
      {
        value: "Directory temporanea",
        description:
          "Cartella relativa usata dal servizio per file temporanei di download feed, normalizzazione e anteprime (default _tmp). Deve essere scrivibile dal processo del microservizio.",
      },
      {
        value: "Log level",
        description:
          "Verbosity dei log applicativi del servizio Python: DEBUG, INFO, WARNING, ERROR, CRITICAL. Il cambio e applicato al salvataggio configurazione insieme al restart del loop schedulato.",
      },
    ],
  },
];
